<div class="container-fluid">

    <section class="pymes-info-producto" *ngIf="productInfo">
        <header class="pymes-info-producto__header">
            <h1 class="pymes-info-producto__title">
                {{ productInfo.TITLE }}
            </h1>

            <div class="pymes-info-producto__subtitle">
                {{ productInfo.SUBTITLE }}
            </div>
        </header>
        <div class="pymes-info-producto__columns">
            <article class="pymes-info-producto__column"
                *ngFor="let column of productInfo.COLUMNS; trackBy: trackByColumn">
                <h2 class="pymes-info-producto__column-title">
                    <span class="pymes-info-producto__column-title-gray">
                        {{ column.TITLE }}
                    </span>

                    <span class="pymes-info-producto__column-title-orange">
                        {{ column.SUBTITLE }}
                    </span>
                </h2>

                <ul class="pymes-info-producto__list">
                    <li class="pymes-info-producto__item" *ngFor="let item of column.ITEMS; trackBy: trackByItem">
                        <ng-container *ngFor="let part of item.PARTS; trackBy: trackByPart">
                            <span [class.pymes-info-producto__text-highlight]="part.HIGHLIGHT"
                                [class.pymes-info-producto__text-muted]="!part.HIGHLIGHT">
                                {{ part.TEXT }}
                            </span>
                        </ng-container>
                    </li>
                </ul>
            </article>
        </div>
    </section>
</div>